import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Collapse
} from 'antd'

import async from 'async'
import _ from 'lodash'
import moment from 'moment'
import ReactHtmlParser from 'react-html-parser'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import {
  blogCategories,
  CustomCkEditor,
  InputBox
} from '../../components/_utils/appUtils'
import { AddBlogFxn } from '../article/actions'
import { searchKeyword } from '../editArticle/actions'
import AddKeyword from '../editArticle/addKeywordDrawer'
import AddTable from './addTable'
import EditTable from './editTable'
import AddBlogInformation from './addBlogInformation'
import AddBlogFaq from './addBlogFaq'

const { Panel } = Collapse


const { Option } = Select
const $ = window.$
const tableDataArr = [
  { name: 'table', label: 'Description' },
  { name: 'figure', label: 'Images' }
]

@Form.create()
class AddBlog extends PureComponent {
  state = {
    fileKey: moment(),
    ckeditorKey: moment() + 1,
    infoData: [],
    affiliationData: [],
    keywords: [],
    featuredImage: '',
    inputVisible: false,
    inputValue: '',
    loop: null,
    page: 1,
    valGet: false,
    editTable: {},
    editInfo: {},
    keywordList: [],
    editVal: {},
    indexVal1: null,
    table: [],
    figure: [],
    plate: [],
    tableDrawerState: {
      visible: false,
      tableType: '',
      tableTitle: ''
    },
    superScriptList: [],
    currentStatus: '',
    drawerVisible: false,
    editIndex: null,
    editData: null,
    faqs: [],
    faqDrawerVisible: false,
    editFaqIndex: null,
    editFaqData: null
  }
  keywordEvents = {
    getKeyword: async value => {
      if (value) {
        let { data } = await searchKeyword({ keyword: value })
        if (data) {
          this.setState({ keywordList: data })
        }
      }
    },
    chooseKeyword: value => {
      let clData = _.clone(this.state.keywords)
      let clDataList = _.clone(this.state.keywordList)
      let findData = _.find(clDataList, item => {
        return item._id == value.key
      })
      clData.push({
        keywordId: findData._id,
        keyword: findData.keyword,
        slugKeyword: findData.slugKeyword
      })
      this.setState({
        keywords: clData,
        keywordList: []
      })
    },

    removeKeyword: id => {
      let clData = _.clone(this.state.keywords)
      clData = _.reject(clData, item => {
        return item.keywordId == id
      })
      this.setState({
        keywords: clData
      })
    }
  }

  events = {
    addData: data => {
      let cloneData = _.clone(this.state[data.tableType])
      cloneData.push(data)
      this.setState({
        [data.tableType]: cloneData
      })
    },
    showDrawer: data => {
      this.setState({
        tableDrawerState: {
          visible: true,
          tableType: data.name,
          tableTitle: data.label
        }
      })
    },

    hideDrawer: () => {
      this.setState({
        tableDrawerState: {
          visible: false,
          tableType: '',
          tableTitle: ''
        }
      })
    },
    deleteItem: (index, tableType) => {
      let cloneData = _.clone(this.state[tableType])
      cloneData = _.reject(cloneData, (item, key) => {
        return key == index
      })
      this.setState({
        [tableType]: cloneData
      })
    },
    onCloseKeyword: () => {
      this.setState({
        open4: false
      })
    },
    showKeywordDrawer: () => {
      this.setState({
        open4: true
      })
    }
  }

  infoEvents = {
    showDrawer: () => {
      this.setState({
        drawerVisible: true,
        editIndex: null,
        editData: null
      })
    },
    hideDrawer: () => {
      this.setState({
        drawerVisible: false,
        editIndex: null,
        editData: null
      })
    },
    addInfoData: (data, index) => {
      let cloneInfoData = _.clone(this.state.infoData)
      if (index !== undefined && index !== null) {
        cloneInfoData[index] = data
      } else {
        cloneInfoData.push(data)
      }

      this.setState({
        infoData: cloneInfoData
      })
    },
    editInfoRow: (item, index) => {
      this.setState({
        editData: item,
        editIndex: index,
        drawerVisible: true
      })
    },
    handleDelete: (title) => {
      let cloneInfoData = _.clone(this.state.infoData)
      let filteredData = _.filter(cloneInfoData, item => item.title !== title)
      this.setState({
        infoData: filteredData
      })
    }
  }

  faqEvents = {
    showDrawer: () => {
      this.setState({
        faqDrawerVisible: true,
        editFaqIndex: null,
        editFaqData: null
      })
    },
    hideDrawer: () => {
      this.setState({
        faqDrawerVisible: false,
        editFaqIndex: null,
        editFaqData: null
      })
    },
    addFaqData: (data, index) => {
      let cloneFaqData = _.clone(this.state.faqs)
      if (index !== undefined && index !== null) {
        cloneFaqData[index] = data
      } else {
        cloneFaqData.push(data)
      }

      this.setState({
        faqs: cloneFaqData
      })
    },
    editFaqRow: (item, index) => {
      this.setState({
        editFaqData: item,
        editFaqIndex: index,
        faqDrawerVisible: true
      })
    },
    handleDelete: (question) => {
      let cloneFaqData = _.clone(this.state.faqs)
      let filteredData = _.filter(cloneFaqData, item => item.question !== question)
      this.setState({
        faqs: filteredData
      })
    }
  }

  constructor(props) {
    super(props)
  }

  stickyHeader = () => {
    $(window).scroll(function() {
      let classCheck = $('aside').hasClass('ant-layout-sider-collapsed')
        ? 'fixedColl'
        : 'fixed'
      if ($(window).scrollTop() >= 250) {
        $('.sticky-header').addClass(classCheck)
        $('.headerPanel').addClass('sticky-header-bg')
      } else {
        $('.sticky-header').removeClass('fixedColl fixed')
        $('.headerPanel').removeClass('sticky-header-bg')
      }
    })
  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  onClose = () => {
    this.setState({
      ['open']: false
    })
  }

  handleDelete = key => {
    const newData = this.state.infoData.filter(item => item.title !== key)
    this.setState({ infoData: newData })
  }

  handleSubmit = async e => {
    const { dispatch, form } = this.props
    let { setFieldsValue } = form
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let {
          infoData,
          keywords,
          featuredImage,
          currentStatus
        } = this.state


        let fd = await new FormData()
        let obj = {
          ...valData,
          infoData: infoData,
          faq: this.state.faqs,
          blogKeywordList: keywords
        }
        if (featuredImage && featuredImage.name) {
          fd.append('featuredImage', featuredImage)
        }

        async.each(
          tableDataArr,
          (item, cb1) => {
            if (this.state[item.name] && this.state[item.name].length) {
              obj[item.name] = _.map(this.state[item.name], item1 => {
                let tempItem = { ...item1 }
                if (tempItem.image && (tempItem.image instanceof File || (tempItem.image.path && tempItem.image.path.startsWith('blob:')))) {
                  tempItem.fileName = tempItem.image.name; 
                  tempItem.image = {
                    name: tempItem.image.name,
                    lastModified: tempItem.image.lastModified,
                    size: tempItem.image.size,
                    type: tempItem.image.type
                  }
                }
                return tempItem
              })
              _.each(this.state[item.name], (item1, key) => {
                if (item1.image && item1.image.name) {
                  fd.append(`${item.name}Images`, item1.image)
                }
              })
              cb1()
            } else {
              obj[item.name] = []
              cb1()
            }
          },
          async () => {
            fd.append('obj', JSON.stringify(obj))
            let resp = await dispatch(AddBlogFxn(fd))
            if (resp && resp.success) {
              notification.success({
                message: resp.message || 'Blog Added Successfully'
              })
              setFieldsValue({
                date: undefined,
                metaTitle: undefined,
                metaDescription: undefined,
                metaKeywords: undefined,
                blogCategory: undefined
              })
              this.setState({
                figure: [],
                table: [],
                oldFeatureImage: {},
                featuredImage: {},
                infoData: [],
                faqs: [],
                fileKey: moment()
              }, () => {
                this.props.dispatch(push('/blogs/list'))
              })
            }
          }
        )
      }
    })
  }

  showDrawer = () => {
    this.setState({
      ['open']: true
    })
  }

  componentDidMount() {
    this.stickyHeader()
    this.loadArticleData()
  }

  loadArticleData = () => {
    /*   let data = getUrlParams('article.addBlog', this.props.pathname)
       if (!!data) {
         let { id } = data
         this.setFormValuesFxn(id)
       }*/
  }

  editTableEvents = {
    showDrawerEditTable: (item, tableType) => {
      let { articleId } = this.state
      this.setState({
        editTable: { ...item, tableType, articleId },
        openTable: true
      })
    },
    hideDrawerEditTable: () => {
      this.setState({
        editTable: {},
        openTable: false
      }, () => {
        this.loadArticleData()
      })
    }
  }

  render() {
    // }

    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue, featuredImage }
    } = this.props
    const {
      oldFeatureImage,
      tableDrawerState
    } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 14 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchema = {
      fields: [
        {
          label: 'Date',
          key: 'date',
          required: true,
          placeholder: 'Date',
          type: 'date',
          span: 8
        },
        {
          label: 'Blog Category',
          key: 'blogCategory',
          required: true,
          showSearch: true,
          options: blogCategories,
          placeholder: 'Blog Category',
          type: 'select',
          span: 8,
          onChange: (val) => {
            setFieldsValue({ blogCategory: val })
          }
        },
        {
          label: 'Featured Image',
          key: 'featuredImage',
          span: 8,
          type: 'file',
          customField: (
            <InputBox title={`Featured Image`} className={'rowFlex'}>
              <Input
                width='100%'
                type={'file'}
                name={'featuredImage'}
                id={'featuredImage'}
                className={'form-control'}
                key={this.state.fileKey}
                onChange={e => {
                  this.chooseDocument(e)
                }}
              />
              {oldFeatureImage && oldFeatureImage.path ? (
                <a
                  className={'linkBtn'}
                  target={'_blank'}
                  href={oldFeatureImage.path}>
                  <Icon type={'eye'} />
                </a>
              ) : null}
            </InputBox>
          )
        },
        {
          label: 'Title',
          key: 'title',
          span: 24,
          type: 'textarea',
          placeholder: 'Title',
          required: true
        },
        {
          label: 'Meta Title',
          key: 'metaTitle',
          type: 'textarea',
          span: 24
        },
        {
          label: 'Meta Description',
          key: 'metaDescription',
          type: 'textarea',
          span: 24
        },
        {
          label: 'Meta Keywords',
          key: 'metaKeywords',
          type: 'textarea',
          span: 24
        }
      ]
    }


    const getColumnField = tableType => {
      let tableColumn = [
        {
          title: ' Image ',
          name: 'image',
          key: 'image',
          dataIndex: 'image',
          width: 200,
          render: image => {
            return <img src={image.path} style={{ height: 80 }} />
          }
        },
        {
          title: ' Key ',
          name: 'key',
          key: 'key',
          dataIndex: 'image',
          width: 200,
          render: (_, record, index) => {
            return (
              <>
                @image{index}
              </>
            )
          }
        },
        {
          title: 'Action',
          name: 'action',
          key: 'action',
          dataIndex: 'action',
          width: 100,
          render: (item, record, index) => {
            return (
              <>
                <Tooltip title='Edit information'>
                  <Button style={{ marginRight: 8, border: 'none', background: 'transparent' }}
                          onClick={e => {
                            this.editTableEvents.showDrawerEditTable(record, tableType)
                          }}
                          icon={'edit'}
                  />
                </Tooltip>
                <Popconfirm
                  title={`Are you Sure, You want to delete?`}
                  onConfirm={e => {
                    this.events.deleteItem(index, tableType)
                  }}
                  okText='Yes'
                  cancelText='No'>
                  <Button style={{ border: 'none', background: 'transparent' }} icon={'delete'} />
                </Popconfirm>
              </>
            )
          }
        }
      ]
      return tableColumn
    }

    const getInfoColumnField = () => {
      return [
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title'
        },
        {
          title: 'Heading',
          dataIndex: 'menuHeading',
          key: 'menuHeading'
        },
        {
          title: 'Content',
          dataIndex: 'description',
          key: 'description',
          render: (text) => <div>{ReactHtmlParser(text)}</div>
        },
        {
          title: 'Action',
          key: 'action',
          width: 100,
          render: (item, record, index) => (
            <>
              <Tooltip title='Edit section'>
                <Button
                  style={{ marginRight: 5 }}
                  shape='circle'
                  icon={'edit'}
                  onClick={() => this.infoEvents.editInfoRow(record, index)}
                />
              </Tooltip>
              <Popconfirm
                title={`Are you Sure, You want to delete?`}
                onConfirm={() => this.infoEvents.handleDelete(record.title)}
                okText='Yes'
                cancelText='No'
              >
                <Button shape='circle' icon={'delete'} />
              </Popconfirm>
            </>
          )
        }
      ]
    }

    return (
      <PageHeaderWrapper
        className={'articleHeader'}
        title={
          <div className={'sticky-header'}>
            <div className={'headerPanel'}>
              <div className='titleDiv'>
                Add Blog
              </div>
            </div>
          </div>
        }>
        <Card bordered={true} className={'doi-form'}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}
            noValidate={true}>
            <Row gutter={16}>
              {inputSchema.fields.slice(0, 4).map((item, key) => {
                return (
                  !item.hidden && (
                    <Col
                      span={item.span ? item.span : 12}
                      md={item.span ? item.span : 12}
                      sm={12}
                      xs={24}
                      key={key}>
                      {item.customField ? (
                        item.customField
                      ) : (
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout}
                        />
                      )}
                    </Col>
                  )
                )
              })}

            </Row>


            <Row gutter={16} style={{ marginTop: 10 }}>
              {inputSchema.fields.slice(4).map((item, key) => {
                return (
                  !item.hidden && (
                    <Col
                      span={item.span ? item.span : 12}
                      md={item.span ? item.span : 12}
                      sm={12}
                      xs={24}
                      key={key}>
                      {item.customField ? (
                        item.customField
                      ) : (
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout}
                        />
                      )}
                    </Col>
                  )
                )
              })}
            </Row>

            {this.state.open4 ? (
              <AddKeyword
                visible={this.state.open4}
                onClose={() => {
                  this.events.onCloseKeyword()
                }}
              />
            ) : null}

            <Card title={'Keywords'}>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item>
                    <Select
                      value={this.state.keywordList}
                      showSearch={true}
                      filterOption={false}
                      labelInValue
                      onChange={this.keywordEvents.chooseKeyword}
                      onSearch={this.keywordEvents.getKeyword}
                      name='keywords'
                      placeholder=' Search Keywords'>
                      {this.state.keywordList &&
                        this.state.keywordList.map(item => (
                          <Option key={item._id}>{item.keyword}</Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Button
                    style={{ marginTop: 3 }}
                    onClick={() => {
                      this.events.showKeywordDrawer()
                    }}
                    className='ant-btn ant-btn-primary'>
                    Add Keyword
                  </Button>
                </Col>
                <Col span={24}>
                  {this.state.keywords &&
                    this.state.keywords.map((item, i) => {
                      return (
                        <>
                          <Tag>
                            {item.keyword}
                            <a
                              onClick={() => {
                                this.keywordEvents.removeKeyword(item.keywordId)
                              }}>
                              <Icon type={'close'} />
                            </a>
                          </Tag>
                        </>
                      )
                    })}
                </Col>
              </Row>
            </Card>

            {tableDataArr.map((item, key) => {
              return (
                <Card
                  key={key}
                  title={item.label + (item.name === 'figure' ? " ( use @image0, @image1... in description )" : "")}
                  extra={
                    <Form.Item
                      name='addTable'
                      style={{ textAlign: 'right', marginTop: 8 }}>
                      <Button
                        size='small'
                        onClick={() => item.name === 'table' ? this.infoEvents.showDrawer() : this.events.showDrawer(item)}
                        className='ant-btn ant-btn-primary'>
                        {item.name === 'table' ? 'Add Description' : 'Add'}
                      </Button>
                    </Form.Item>
                  }>
                  <Col span={24} className={'custom_card'}>
                    {item.name === 'table' ? (
                      this.state.infoData && this.state.infoData.length ? (
                        <Collapse accordion>
                          {this.state.infoData.map((infoItem, infoIndex) => (
                            <Panel
                              header={`${infoItem.title} (${infoItem.menuHeading})`}
                              key={infoIndex}
                              extra={
                                <div onClick={e => e.stopPropagation()}>
                                  <Tooltip title='Edit section'>
                                    <Button
                                      style={{ marginRight: 8, border: 'none', background: 'transparent' }}
                                      size='small'
                                      icon={'edit'}
                                      onClick={() => this.infoEvents.editInfoRow(infoItem, infoIndex)}
                                    />
                                  </Tooltip>
                                  <Popconfirm
                                    title={`Are you Sure, You want to delete?`}
                                    onConfirm={() => this.infoEvents.handleDelete(infoItem.title)}
                                    okText='Yes'
                                    cancelText='No'
                                  >
                                    <Button
                                      style={{ border: 'none', background: 'transparent' }}
                                      size='small'
                                      icon={'delete'}
                                    />
                                  </Popconfirm>
                                </div>
                              }
                            >
                              <div className='collapse_content'>
                                {ReactHtmlParser(infoItem.description)}
                              </div>
                            </Panel>
                          ))}
                        </Collapse>
                      ) : null
                    ) : (
                      this.state[item.name] && this.state[item.name].length ? (
                        <Table
                          className={'figureTable'}
                          bordered={true}
                          dataSource={this.state[item.name]}
                          columns={getColumnField(item.name)}
                          size={'small'}
                          pagination={false}
                        />
                      ) : null
                    )}
                  </Col>
                </Card>
              )
            })}

            <Card
              title={'FAQs'}
              extra={
                <Form.Item
                  name='addFaq'
                  style={{ textAlign: 'right', marginTop: 8 }}>
                  <Button
                    size='small'
                    onClick={() => this.faqEvents.showDrawer()}
                    className='ant-btn ant-btn-primary'>
                    Add FAQ
                  </Button>
                </Form.Item>
              }>
              <Col span={24} className={'custom_card'}>
                {this.state.faqs && this.state.faqs.length ? (
                  <Collapse accordion>
                    {this.state.faqs.map((faqItem, faqIndex) => (
                      <Panel
                        header={`${faqItem.question}`}
                        key={faqIndex}
                        extra={
                          <div onClick={e => e.stopPropagation()}>
                            <Tooltip title='Edit FAQ'>
                              <Button
                                style={{ marginRight: 8, border: 'none', background: 'transparent' }}
                                size='small'
                                icon={'edit'}
                                onClick={() => this.faqEvents.editFaqRow(faqItem, faqIndex)}
                              />
                            </Tooltip>
                            <Popconfirm
                              title={`Are you Sure, You want to delete?`}
                              onConfirm={() => this.faqEvents.handleDelete(faqItem.question)}
                              okText='Yes'
                              cancelText='No'
                            >
                              <Button
                                style={{ border: 'none', background: 'transparent' }}
                                size='small'
                                icon={'delete'}
                              />
                            </Popconfirm>
                          </div>
                        }
                      >
                        <div className='collapse_content'>
                          {ReactHtmlParser(faqItem.answer)}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>
                ) : null}
              </Col>
            </Card>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>

          {tableDrawerState.visible ? (
            <AddTable
              title={tableDrawerState.tableTitle}
              tableType={tableDrawerState.tableType}
              visible={tableDrawerState.visible}
              hideDescription={true}
              addTableData={this.events.addData}
              onClose={() => {
                this.events.hideDrawer()
              }}
            />
          ) : null}

          <AddBlogInformation
            visible={this.state.drawerVisible}
            onClose={this.infoEvents.hideDrawer}
            addDetails={this.infoEvents.addInfoData}
            data={this.state.editData}
            editIndex={this.state.editIndex}
            arrayData={this.state.infoData}
            editInfoRow={this.infoEvents.editInfoRow}
            handleDelete={this.infoEvents.handleDelete}
          />

          <AddBlogFaq
            visible={this.state.faqDrawerVisible}
            onClose={this.faqEvents.hideDrawer}
            addDetails={this.faqEvents.addFaqData}
            data={this.state.editFaqData}
            editIndex={this.state.editFaqIndex}
            arrayData={this.state.faqs}
            editInfoRow={this.faqEvents.editFaqRow}
            handleDelete={this.faqEvents.handleDelete}
          />

          {this.state.editTable && this.state.openTable ? (
            <EditTable
              title={this.state.editTable.tableType}
              visible={this.state.openTable}
              editTable={this.state.editTable}
              hideDescription={true}
              onClose={() => {
                this.editTableEvents.hideDrawerEditTable()
              }}
            />
          ) : null}


        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddBlog)
